"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ItemCard extends Marko.Component {
    onInput(input) {
        this.state = input;
    }
}
exports.default = ItemCard;
